// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"2222":"components-hero-with-image","5268":"Home","5592":"components-html-form","6693":"components-video"}[chunkId] + "-" + {"2222":"e4d84a4f8e274a82b283","5268":"05b8f3ba0bebd901cd8b","5592":"b8386d4e68262a0f647b","6693":"f6f3566e7e0ef3850da5"}[chunkId] + ".css";
};